import type { TypedMyHotelAccess } from './-MyHotelAccess';
import RawMyHotelAccess from './MyHotelAccess.vue';
export * from './-MyHotelAccess';
export const MyHotelAccess = RawMyHotelAccess as typeof TypedMyHotelAccess;
